/**
 * 11.可复用维度排名变化表，展示当前排名与变化值。 Figma：81174:35977。
 */

import type { DimensionRankChange } from "./type";
import { cn } from "utils";
import { useJsonRenderRuntimeContext } from "../jsonRender/JsonRenderRuntimeContext";

export interface AssetDimensionRankChangeTableProps {
  rows: DimensionRankChange[];
  dimensionLabel?: string;
  rankLabel?: string;
  changeLabel?: string;
}

export const AssetDimensionRankChangeTable: React.FC<
  AssetDimensionRankChangeTableProps
> = ({
  rows,
  dimensionLabel = "Dimension",
  rankLabel = "Rank",
  changeLabel = "Change",
}) => {
  const runtimeContext = useJsonRenderRuntimeContext();
  const stickyBgClass =
    runtimeContext?.scene === "chat"
      ? "bg-background_solid_primary"
      : "bg-background_solid_secondary";

  return (
    <div
      className="w-full overflow-x-auto no-scrollbar"
      style={{ overscrollBehavior: "auto" }}
    >
      <div className="flex min-w-full w-max flex-col">
        {rows.length > 0 && (
          <div className="mt-2 flex w-full border-b border-border_white_transparent10">
            <div
              className={cn(
                "sticky left-0 z-[2] flex min-w-[120px] shrink-0 flex-1 items-center p-2",
                stickyBgClass,
              )}
            >
              <span className="body_s text-content_quaternary">
                {dimensionLabel}
              </span>
            </div>
            <div className="flex min-w-[72px] shrink-0 flex-1 items-center justify-center p-2">
              <span className="body_s text-content_quaternary">
                {rankLabel}
              </span>
            </div>
            <div className="flex min-w-[72px] shrink-0 flex-1 items-center justify-center p-2">
              <span className="body_s text-content_quaternary">
                {changeLabel}
              </span>
            </div>
          </div>
        )}
        {rows.map((metric, idx) => (
          <div
            key={`${metric.dimensionKey}-${idx}`}
            className="flex w-full border-b border-border_white_transparent10 last:border-b-0"
          >
            <div
              className={cn(
                "sticky left-0 z-[1] flex min-h-12 min-w-[120px] shrink-0 flex-1 items-center px-2 py-1.5",
                stickyBgClass,
              )}
            >
              <span className="body_m text-content_tertiary">
                {metric.dimensionName}
              </span>
            </div>
            <div className="flex min-h-12 min-w-[72px] shrink-0 flex-1 items-center justify-center px-2 py-1.5">
              <div className="flex items-center leading-none whitespace-nowrap">
                <span className="body_bold_l text-content_brand_primary">
                  {metric.rankValue}
                </span>
                <span className="body_m text-content_quaternary">
                  {metric.rankTotalAssets
                    ? `/${metric.rankTotalAssets}`
                    : "/100"}
                </span>
              </div>
            </div>
            <div className="flex min-h-12 min-w-[72px] shrink-0 flex-1 items-center justify-center px-2 py-1.5">
              <span className="button_l text-content_brand_primary">
                {metric.rankChange}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
